import React, { useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faUpload } from "@fortawesome/pro-solid-svg-icons";

import "./customerImage.scss";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

type CustomerImageProps = {
  imageSource: string | null;
  saveProfileImage?: (imageFile: File) => void;
  deleteProfileImage?: () => void;
  circleImage?: boolean;
};

export default function CustomerImage(props: CustomerImageProps) {
  const imageUploadInputRef = useRef(null);
  const { imageSource, saveProfileImage, deleteProfileImage, circleImage } = props;
  const { t } = useTranslation();

  function imageUploadOnChange(event: React.ChangeEvent<HTMLInputElement>) {
    const file = event.target.files;
    if (file && file.length > 0) {
      //Upload image after the file is selected
      void saveProfileImage(file[0]);

      //Reset file selector input value
      imageUploadInputRef.current.value = "";
    }
  }

  return (
    <div className="customer-image_grid" style={{ gridGap: "0rem" }}>
      {imageSource ? (
        <div>
          <div className={classNames("product-image_container", { "product-image_container_circle": circleImage })}>
            <div className="product-image">
              {props.deleteProfileImage ? (
                <div
                  className={classNames("remove-button_container", { "remove-button_container_circle": circleImage })}
                >
                  <div className="remove-button" onClick={deleteProfileImage}>
                    <FontAwesomeIcon icon={faTimes} />
                  </div>
                </div>
              ) : null}
              <img src={imageSource} alt={t('profile image')} />
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="product-image-upload_container">
            <div className="product-image-upload_content">
              <input
                ref={imageUploadInputRef}
                className="product-image-upload_input"
                type="file"
                accept="image/*"
                onChange={imageUploadOnChange}
              />
              <p>
                <FontAwesomeIcon icon={faUpload} />
              </p>
            </div>
          </div>
          <div className="product-image-upload_content"></div>
        </>
      )}
    </div>
  );
}
